import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row footer q-px-xs-xs q-px-lg-lg" }
const _hoisted_2 = { id: "footer-menu" }
const _hoisted_3 = { style: {"color":"white !important"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Sitemap", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Over de BRO Monitor", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Cookies en privacy", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Kwetsbaarheid melden", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Toegankelijkheid", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, { class: "text-white bg-secondary footer" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.cssOverride)
        }, [
          _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("footer.over")), 1)
            ]),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'sitemap' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "keyboard_arrow_right"
                    }),
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'overdebromonitor' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "keyboard_arrow_right"
                    }),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'cookies_privacy' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "keyboard_arrow_right"
                    }),
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'kwetsbaarheid-melden' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "keyboard_arrow_right"
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: { name: 'toegankelijkheid' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      color: "white",
                      name: "keyboard_arrow_right"
                    }),
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}